module.exports = __webpack_public_path__ + "img/8.06d22cea.jpg";